import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
  showIcon?: boolean;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  showIcon = true
}: CTAButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={`
        w-full md:w-auto flex items-center justify-center space-x-3
        bg-wellness-primary hover:bg-wellness-light text-white
        font-semibold text-lg md:text-xl py-4 px-8 rounded-xl
        shadow-[0_8px_20px_rgba(74,124,89,0.3)] transition-colors
        animate-subtle-pulse ${className}
      `} data-id="element-17">
      <span data-id="element-18">{children}</span>
      {showIcon && <ArrowRightIcon className="w-6 h-6" data-id="element-19" />}
    </motion.button>;
}